import { WSTableCell } from "@wingspanhq/fe-component-library";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";
import { TaxFormSubmissionRow } from "../../../services/search";
import { selector1099Total } from "../selectors/selector1099Total";
import { selectorIsTaxFormProcessing } from "../selectors/selectorIsTaxFormProcessing";

export type NEC1099TotalCellProps = {
  taxFormSubmission: TaxFormSubmissionRow;
};

export const NEC1099TotalCell: React.FC<NEC1099TotalCellProps> = ({
  taxFormSubmission
}) => {
  const nec1099Total = selector1099Total(taxFormSubmission);
  const isProcessing = selectorIsTaxFormProcessing(taxFormSubmission);

  return !isProcessing &&
    Number.isFinite(nec1099Total) &&
    nec1099Total !== undefined ? (
    <WSTableCell
      text={formatMoney(nec1099Total, "USD")}
      secondaryText={taxFormSubmission.isGrouped ? "Grouped" : undefined}
    />
  ) : (
    <WSTableCell
      text="--"
      tooltip={
        isProcessing
          ? "The tax forms have been created but the amounts are still loading. Please wait a few minutes for all amounts to be processed before they appear on the forms. "
          : undefined
      }
      secondaryText={isProcessing ? "Processing" : undefined}
    />
  );
};
